import { Link, useNavigate } from "react-router-dom";

const StartQuiz = ({ id }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="d-grid gap-3 mb-3">
        <button
          className="btn btn-lg fw-bold py-3 bg-gradient-primary text-white "
          onClick={() => navigate(`/assessment/test/${id}`)}
        >
          🚀 Start Assessment
        </button>
        <button className="btn btn-outline-light btn-lg">
          👁️ Preview Questions
        </button>
        <button className="btn btn-outline-light" onClick={() => navigate(-1)}>
          ← Back to Quiz Library
        </button>
      </div>
    </>
  );
};

export default StartQuiz;
